/** Title / pause / win screens (§8.7). HTML overlay; chunky buttons; no in-world text. */
export interface TitleOptions {
  hasSave: boolean;
  sensitivity: number;
  volume: number;
  onNew: (mode: 'A' | 'B') => void;
  onContinue: () => void;
  onSensitivity: (v: number) => void;
  onVolume: (v: number) => void;
}

const CONTROLS = `
<div class="controls">
  <b>Mouse</b><span>look</span>
  <b>W A S D</b><span>move</span>
  <b>Shift</b><span>run</span>
  <b>Space</b><span>dodge roll</span>
  <b>LMB</b><span>attack (sword)</span>
  <b>E</b><span>pick up · swap · drop</span>
  <b>F</b><span>use what you hold</span>
  <b>Esc</b><span>pause</span>
</div>`;

export class Screens {
  private el: HTMLDivElement | null = null;
  constructor(private readonly root: HTMLElement) {}

  private show(html: string): HTMLDivElement {
    this.hide();
    const el = document.createElement('div');
    el.className = 'screen';
    el.innerHTML = html;
    this.root.appendChild(el);
    this.el = el;
    return el;
  }
  hide(): void { if (this.el) { this.el.remove(); this.el = null; } }
  get visible(): boolean { return !!this.el; }

  title(o: TitleOptions): void {
    const el = this.show(`
      <h1>THRESHOLD</h1>
      <h2>bring the Chalice home</h2>
      <div class="menu">
        <button class="chunky primary" data-a="A">New game</button>
        <button class="chunky" data-a="B">New game · shuffled</button>
        <button class="chunky" data-a="continue" ${o.hasSave ? '' : 'disabled'}>Continue</button>
      </div>
      <div class="row"><span>mouse</span><input type="range" min="0.0008" max="0.006" step="0.0001" value="${o.sensitivity}" data-r="sens"><span>sound</span><input type="range" min="0" max="1" step="0.05" value="${o.volume}" data-r="vol"></div>
      ${CONTROLS}
      <p>You carry one thing. Keys open keeps. Beasts keep to their lands. The bird takes what you leave lying around.</p>
    `);
    el.querySelectorAll<HTMLButtonElement>('button').forEach((b) => b.addEventListener('click', () => {
      const a = b.dataset.a;
      if (a === 'continue') o.onContinue(); else o.onNew(a as 'A' | 'B');
    }));
    el.querySelector<HTMLInputElement>('[data-r=sens]')!.addEventListener('input', (e) => o.onSensitivity(parseFloat((e.target as HTMLInputElement).value)));
    el.querySelector<HTMLInputElement>('[data-r=vol]')!.addEventListener('input', (e) => o.onVolume(parseFloat((e.target as HTMLInputElement).value)));
  }

  pause(held: string | null, onResume: () => void, onQuit: () => void, sensitivity: number, onSensitivity: (v: number) => void): void {
    const el = this.show(`
      <h2>paused</h2>
      <p>${held ? 'You are carrying the <b>' + held + '</b>.' : 'Your hands are empty.'}</p>
      <div class="menu">
        <button class="chunky primary" data-a="resume">Resume</button>
        <button class="chunky" data-a="quit">Title</button>
      </div>
      <div class="row"><span>mouse</span><input type="range" min="0.0008" max="0.006" step="0.0001" value="${sensitivity}" data-r="sens"></div>
      ${CONTROLS}
    `);
    el.querySelector<HTMLButtonElement>('[data-a=resume]')!.addEventListener('click', onResume);
    el.querySelector<HTMLButtonElement>('[data-a=quit]')!.addEventListener('click', onQuit);
    el.querySelector<HTMLInputElement>('[data-r=sens]')!.addEventListener('input', (e) => onSensitivity(parseFloat((e.target as HTMLInputElement).value)));
  }

  win(stats: { time: number; deaths: number; secret: boolean; mode: 'A' | 'B' }, onAgain: (mode: 'A' | 'B') => void): void {
    const m = Math.floor(stats.time / 60), s = Math.floor(stats.time % 60);
    const el = this.show(`
      <h1>THRESHOLD</h1>
      <h2>the Chalice is home</h2>
      <div class="stat">time <b>${m}:${s.toString().padStart(2, '0')}</b> · deaths <b>${stats.deaths}</b> · mode <b>${stats.mode}</b>${stats.secret ? ' · <span class="mark">◆</span>' : ''}</div>
      <div class="menu">
        <button class="chunky primary" data-a="B">${stats.mode === 'A' ? 'Again · shuffled (Mode B)' : 'Again · shuffled'}</button>
        <button class="chunky" data-a="A">Again · Mode A</button>
      </div>
    `);
    el.querySelectorAll<HTMLButtonElement>('button').forEach((b) => b.addEventListener('click', () => onAgain(b.dataset.a as 'A' | 'B')));
  }
}
